import { red } from "@material-ui/core/colors";
import shadows from "@material-ui/core/styles/shadows";

const signupPageStyle = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3
    // overflowX: "auto"
  },
  table: {
    minWidth: "700px"
    // shadows: "none"
  },
  tableHeader: {
    backgroundColor: "#303c4a",
    margin: "0",
    padding: "0",
    fontSize: "0.9rem"
  },

  tableText: {
    // backgroundColor: "red",
    margin: "0",
    padding: "0",
    fontSize: "0.9rem"
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.white
    },
    "&:hover": {
      backgroundColor: theme.palette.grey[100]
    }
  },
  temp: {},
  docItemTitle: {
    // backgroundColor: "#000",
    color: "#2e2e2e",
    marginLeft: "20px",
    width: "20%",
    fontWeight: "600"
  },
  docItemMemo: {
    // backgroundColor: "#123"
    color: "#858584",
    marginLeft: "10px",
    width: "70%"
  },
  docItem: {
    width: "700px",
    borderBottom: "1px solid #eee",
    display: "flex",
    height: "50px",
    alignItems: "center"
  },
  docItemFileLabel: {
    color: "#858584",
    paddingLeft: "10px"
    // textDecoration: "underline"
  },
  docItemFileimg: {
    color: "#808080",
    width: "25px",
    height: "25px"
  },
  fab: {
    color: "#fff",
    backgroundColor: "#303c4a",
    float: "right",
    margin: "20px",
    "&:hover,&:focus": {
      backgroundColor: "#212b37",
      color: "#fff"
    }
  },
  docInputText: {
    padding: "10px",
    border: "0px",
    fontSize: "0.97rem",
    backgroundColor: "#f8f8f8"
  },
  docInputTextArea: {
    padding: "10px",
    border: "0px",
    fontSize: "0.97rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    backgroundColor: "#f8f8f8"
  },
  textFieldInsert: {
    margin: "10px",
    // backgroundColor: "#000"
    borderColor: "#80bdff",
    outlined: "#000"
  },
  empList: { zIndex: 1000 }
});

export default signupPageStyle;
